import { ResultsGrid } from './ResultsGrid';
import { connectResultsGrid } from './ResultsGrid.connect';

export const ConnectedResultsGrid = connectResultsGrid(ResultsGrid);
ConnectedResultsGrid.displayName = 'ConnectedResultsGrid';
